import React from 'react'
import Voucher from './Voucher'

const index = () => {
  return <Voucher />
}

export default index